"use strict";
/**
 * This module exists to prevent circular dependency between the `nutrition` module and the `index` module in this directory.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NominalMixRatio = exports.MixRatioScalarsFromUnsorted = exports.MixRatioScalars = exports.MixRatioScalar = void 0;
const effect_1 = require("effect");
const Array_1 = require("effect/Array");
const NAMESPACE = 'Culligan.Device.Capability.Consumable.Definition.Enhancement.MixRatio';
const ensureNonEmpty = (xs) => {
    if (effect_1.Array.isNonEmptyReadonlyArray(xs)) {
        return xs;
    }
    else {
        throw new TypeError('Array cannot be empty');
    }
};
const mixRatioScalarsAnnotations = {
    description: 'Allowed deviation-scalars relative to the `nominalMixRatio`. ' +
        'For example, a `mixRatioScalar` of 2 would mix an enhancement with a ' +
        '`nominalMixRatio` of 200 at a ratio of 100:1 instead, since 200 / 2 equals 100. ' +
        'A `mixRatioScalar` of 1 would mix the enhancement at the `nominalMixRatio`.',
    arbitrary: () => () => effect_1.Arbitrary.make(effect_1.Schema.NonEmptyArray(effect_1.Schema.Positive)).map(ns => (0, effect_1.pipe)(ns, (0, Array_1.sort)(effect_1.Order.number), Array_1.dedupeAdjacent, ensureNonEmpty)),
};
exports.MixRatioScalar = effect_1.Schema.Positive.annotations({
    identifier: `${NAMESPACE}.MixRatioScalar`,
});
exports.MixRatioScalars = effect_1.Schema.NonEmptyArray(exports.MixRatioScalar)
    .pipe(effect_1.Schema.filter(scalars => scalars.length === new Set(scalars).size, {
    jsonSchema: { uniqueItems: true },
}))
    .annotations({
    identifier: `${NAMESPACE}.MixRatioScalars`,
    ...mixRatioScalarsAnnotations,
});
exports.MixRatioScalarsFromUnsorted = effect_1.Schema.transform(exports.MixRatioScalars, exports.MixRatioScalars, {
    decode: (0, Array_1.sort)(effect_1.Order.number),
    encode: effect_1.identity,
    strict: true,
}).annotations({
    identifier: `${NAMESPACE}.MixRatioScalarsFromUnsorted`,
    ...mixRatioScalarsAnnotations,
});
exports.NominalMixRatio = effect_1.Schema.Positive.annotations({
    identifier: `${NAMESPACE}.NominalMixRatio`,
    description: 'The standard, or manufacturer-recommended ratio between water-weight and enhancement-weight to mix this enhancement at. ' +
        'For example, if the enhancement is supposed to be mixed at a 200-parts-water : 1-part-enhancement ratio, ' +
        'the `nominalMixRatio` would be 200.',
});
//# sourceMappingURL=mix-ratio.js.map